<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content
  ><p>{{ data.message }}</p>
  <p>{{ data.question }}</p>
</mat-dialog-content>
<mat-dialog-actions class="button-group" align="end">
  <button
    mat-button
    [mat-dialog-close]="false"
    [innerHtml]="data.falseText ?? 'dialog.false' | translate"
  ></button>
  <button
    mat-button
    [mat-dialog-close]="true"
    [innerHtml]="data.trueText ?? 'dialog.true' | translate"
  ></button>
</mat-dialog-actions>
